{
  "page": { "title": "รายงานสต๊อกเข้า", "subtitle": "{{count}} เอกสารในช่วงนี้" },
  "column": {
    "doc_no": "เลขเอกสาร",
    "doc_type": "ประเภท",
    "load_date": "วันที่",
    "load_time": "เวลา",
    "sku": "SKU",
    "quantity": "จำนวน",
    "tran_type": "ทิศทาง",
    "remark": "หมายเหตุ",
    "ref_no": "อ้างอิง"
  },
  "direction": { "IN": "เข้า", "OUT": "ออก" },
  "kpi": {
    "docs_in_range": "เอกสารในช่วง",
    "total_received": "จำนวนรับเข้ารวม",
    "last_inbound": "รับเข้าล่าสุด"
  },
  "toolbar": {
    "search_placeholder": "ค้นหาเอกสาร, SKU หรือเลขอ้างอิง…",
    "export": "ส่งออก",
    "date_from": "จาก",
    "date_to": "ถึง"
  },
  "state": {
    "empty": "ไม่มีเอกสารสต๊อกเข้าในช่วงนี้",
    "error": "ไม่สามารถโหลดรายงานสต๊อกเข้าได้",
    "none": "—"
  }
}
